import * as React from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const StyledGridOverlay = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
  '& .no-rows-primary': {
    fill: '#3D4751',
    ...theme.applyStyles('light', {
      fill: '#AEB8C2',
    }),
  },
  '& .no-rows-secondary': {
    fill: '#1D2126',
    ...theme.applyStyles('light', {
      fill: '#E8EAED',
    }),
  },
}));

export function NoSegmentRowsOverlay() {
  return (
    <StyledGridOverlay>
      <Box sx={{ mt: 2, textAlign: 'center' }}>
        You haven&apos;t made any selections yet.
      </Box>

    </StyledGridOverlay>
  );
}
